import { render, staticRenderFns } from "./bubbleBg.vue?vue&type=template&id=636f6c7c&scoped=true"
import script from "./bubbleBg.vue?vue&type=script&lang=js"
export * from "./bubbleBg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636f6c7c",
  null
  
)

export default component.exports